var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RichText',{class:_vm.$style.textContainer,attrs:{"text-params":_vm.primary.text,"data-luko-tracking":"TextBlock"}})}
var staticRenderFns = []

export { render, staticRenderFns }